<template>
  <div
    class="tangram-goods"
    :style="module.containerStyle"
    :data-tangram-module-id="module.id"
  >
    <!-- 普通样式 -->
    <ul
      v-if="module.data.tabs.length && module.isGroup"
      class="tabs"
      :style="{
        top: stickyTop,
        backgroundColor: tabStyle.titleBgColor
      }"
    >
      <li
        v-for="(tab, index) in module.data.tabs"
        :key="index"
        :class="{
          current: index === currentIndex
        }"
        @click="switchTab(index)"
      >
        <p
          :style="{
            color:
              index === currentIndex
                ? tabStyle.selectedTitleColor
                : tabStyle.unselectTitleColor,
            backgroundColor:
              index === currentIndex ? tabStyle.selectedColor : ''
          }"
        >
          {{ tab.name }}
        </p>
      </li>
    </ul>
    <!-- 十亿补贴 -->
    <ul
      v-if="module.data.tabs.length && module.isBillionGoodsGroup"
      class="tabs billion-tabs"
      :style="{
        top: stickyTop
      }"
    >
      <li
        v-for="(tab, index) in module.data.tabs"
        :key="tab.group_id"
        :class="{
          current: index === currentIndex
        }"
        @click="switchTab(index)"
      >
        <p :style="index === currentIndex ? module.tabCurrentStyle : {}">
          {{ tab.name }}
        </p>
      </li>
    </ul>

    <div
      v-for="(group, index) in module.data.goods[currentIndex]"
      :key="index"
      :class="[
        'group',
        {
          'can-scroll': canScroll,
          'flex-start':
            index === module.data.goods[currentIndex].length - 1 &&
            group.length < module.factor
        }
      ]"
      :style="{
        'margin-bottom':
          index === module.data.goods[currentIndex].length - 1 && !isXN
            ? '0'
            : module.elementMarginCalculated
      }"
    >
      <template v-for="good in group">
        <component
          :is="componentType"
          :key="good.ssu.ssuInfo.ssuId"
          v-tangram-expose="
            Object.assign({}, good.ssu.ssuInfo.tickerInfo, {
              extraTrack: good.ssu.extraTrack
            })
          "
          :ssu="good.ssu"
          :sku-index="index"
          :style="
            index === module.data.goods[currentIndex].length - 1 &&
            group.length < module.factor
              ? Object.assign(good.goodStyle, {
                  'margin-right': module.elementMarginCalculated
                })
              : good.goodStyle
          "
          :good-width="good.goodWidth"
          :type="module.layoutType"
        />
      </template>
    </div>
  </div>
</template>

<script>
import newSoleGood from './components/new-sole-good.vue'
import newDoubleGood from './components/new-double-good.vue'
import newTrisScrollGood from './components/new-tris-scroll-good.vue'

import newSoleGoodBillon from './components/new-sole-good-billon.vue'
import newTrisScrollGoodBillon from './components/new-tris-scroll-good-billon.vue'

import { miniProgramEnv } from '@/defines/environment'
import { router } from '@/router'

const newEnumComponentType = {
  sole: 'new-sole-good',
  double: 'new-double-good',
  tris: 'new-tris-scroll-good',
  scroll: 'new-tris-scroll-good'
}

const billionEnumComponentType = {
  sole: 'new-sole-good-billon',
  tris: 'new-tris-scroll-good-billon',
  scroll: 'new-tris-scroll-good-billon'
}

export default {
  components: {
    newSoleGood,
    newDoubleGood,
    newTrisScrollGood,
    newSoleGoodBillon,
    newTrisScrollGoodBillon
  },
  props: {
    module: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  computed: {
    tabStyle() {
      return this.module.tabStyle || {}
    },
    componentType() {
      if (this.module?.isBillionCmsCode) {
        return billionEnumComponentType[this.module.layoutType]
      } else {
        return newEnumComponentType[this.module.layoutType]
      }
    },
    // 1*N商品
    isXN() {
      return this.module.layoutType === 'sole'
    },
    canScroll() {
      return this.module.layoutType === 'scroll'
    },
    stickyTop() {
      if (router.currentRoute.name === 'shop') return '0px'
      if (miniProgramEnv.isMiniProgram) return '0px'
      return this.statusBarHeight + 44 + 'px'
    }
  },
  methods: {
    switchTab(index) {
      this.currentIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.tangram-goods {
  .tabs {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 3;

    overflow-x: auto;

    margin-bottom: 0.16rem;

    box-shadow: 0 0.06rem 0.1rem -0.04rem rgba(153, 153, 153, 0.23);

    @include flex(row, flex-start, center, nowrap);
    li {
      height: 45px;

      // background-color: white;
      list-style: none;

      flex: 1;

      @include flex-row-center;

      p {
        margin: 0 4px;

        flex: none;

        font-size: 15px;
        line-height: 28px;

        color: $c-text-normal;

        @include text-overflow-ellipsis-single;
      }

      &.current {
        p {
          padding: 0 8px;

          // background-image: linear-gradient(-90deg, #f38b4d 0%, #f76b1c 100%);
          border-radius: 15px;

          flex: none;

          // color: white;
          // box-shadow: 0 2px 4px 1px rgba(247, 111, 35, 0.24);
        }
      }
    }
    &.billion-tabs {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      left: 0;
      z-index: 3;

      margin-bottom: 0.24rem;

      box-shadow: 'none';

      @include flex(row, flex-start, center, nowrap);
      li {
        height: auto;

        background-color: transparent;
        list-style: none;

        flex: 1;

        @include flex-row-center;

        p {
          background-repeat: no-repeat;
          background-size: 100% auto;

          flex: none;

          font-size: 16px;
          line-height: 32px;
          font-weight: bold;

          color: $c-text-normal;

          @include text-overflow-ellipsis-single;
        }

        &.current {
          p {
            width: 100%;

            box-sizing: border-box;

            border-radius: 15px;

            flex: none;

            text-align: center;

            color: white;
          }
        }
      }
    }
  }
  .group {
    width: 100%;

    @include flex-row-between;

    &.flex-start {
      @include flex(row, flex-start, flex-start, nowrap);
    }

    &.can-scroll {
      overflow-x: auto;
      @include flex(row, flex-start, flex-start, nowrap);
    }
  }
}
</style>
